'use es6';

const SCREENS_WITH_CUSTOM_METRICS_TOOLTIPS = ['CAMPAIGNS'];
export const getMetricTooltipLangKey = ({
  key,
  screen,
  baseKey
}) => {
  if (SCREENS_WITH_CUSTOM_METRICS_TOOLTIPS.includes(screen)) {
    return `${baseKey}.${screen}.${key}`;
  }
  return `${baseKey}.DEFAULT.${key}`;
};
export const getLearnMoreUrl = ({
  learnMoreUrls,
  metric
}) => {
  if (!learnMoreUrls) {
    return null;
  }
  if (typeof learnMoreUrls === 'object') {
    return learnMoreUrls[metric];
  }
  return learnMoreUrls;
};